import { atomWithStorage } from "jotai/utils";
import { makeSessionJsonStorage, withPrefix } from "./storage";

// recently used item (stop or line)
export type RecentItem = { kind: "stop" | "line"; id: string; ts: number };

// last used items (stops/lines), per tab (sessionStorage)
export const recentItemsAtom = atomWithStorage<RecentItem[]>(
  withPrefix("recent-items"),
  [],
  makeSessionJsonStorage<RecentItem[]>()
);
